export const DEPARTURE_TICKET = "departureTicket"
export const RETURN_TICKET = "returnTicket"
export const DEPARTURE_SEGMENT = "departureSegment"
export const RETURN_SEGMENT = "returnSegment"

export const EXPRESS_AT_HOME_CLASS = "Y"
